import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { SiteContentContext } from '../context/SiteContentContext';
import QuestionModal from '../components/QuestionModal';
import { useSeo } from '../hooks/useSeo';
import '../styles/profile_page.css';
import '../styles/fleet_page.css';

const FleetPage = ({ isPreview = false }) => {
  useSeo({
    title: 'Флот',
    description: 'Яхты парусной школы The Sailing Doctor — современные суда с полным комплектом снаряжения для обучения, путешествий и регат.',
  });
  const { content } = useContext(SiteContentContext);
  const [isQuestionOpen, setIsQuestionOpen] = useState(false);
  const yachts = content.yachts || [];
  const p = isPreview ? '/preview' : '';

  return (
    <main>
      <section className={`fleet-page-hero${content.fleetHeroImage ? " has-cover" : ""}`} style={content.fleetHeroImage ? { backgroundImage: `url(${content.fleetHeroImage})` } : {}}>
        <h1>Наш флот</h1>
        <p>Современные яхты для обучения, путешествий и регат</p>
      </section>
      <div className="fleet-page">

      {yachts.length === 0 ? (
        <div className="fleet-page-empty">
          <p>Яхты ещё не добавлены. Зайдите в <Link to="/admin">админку</Link> и добавьте их во вкладке ⛵ Яхты.</p>
        </div>
      ) : (
        <div className="fleet-page-grid">
          {yachts.map(yacht => (
            <Link key={yacht.id} to={`${p}/yacht/${yacht.name.toLowerCase().replace(/\s+/g, '-')}`} className="fleet-card">
              <div className="fleet-card-photo">
                {yacht.photo
                  ? <img src={yacht.photo} alt={yacht.name} className="fleet-card-photo-img" />
                  : <span className="fleet-card-no-photo">⛵</span>}
              </div>
              <div className="fleet-card-body">
                <h2>{yacht.name}</h2>
                {yacht.model && <p className="fleet-card-model">{yacht.model}</p>}
                <ul className="fleet-card-specs">
                  {yacht.length && <li><span>Длина</span><strong>{yacht.length}</strong></li>}
                  {yacht.cabins && <li><span>Каюты</span><strong>{yacht.cabins}</strong></li>}
                  {yacht.capacity && <li><span>Вместимость</span><strong>{yacht.capacity} чел.</strong></li>}
                  {yacht.year && <li><span>Год</span><strong>{yacht.year}</strong></li>}
                </ul>
                {yacht.description && <p className="fleet-card-desc">{yacht.description}</p>}
                <span className="fleet-card-more">Подробнее →</span>
              </div>
            </Link>
          ))}
        </div>
      )}
      </div>
      <section className="cta-section">
        <h2>Остались вопросы?</h2>
        <p>Напишите нам — расскажем о яхтах и условиях. Ответим в течение дня.</p>
        <button className="cta-button" onClick={() => setIsQuestionOpen(true)}>Задать вопрос</button>
      </section>
      <QuestionModal isOpen={isQuestionOpen} onClose={() => setIsQuestionOpen(false)} pageTitle="Флот" />
    </main>
  );
};

export default FleetPage;
